import Vue from 'vue';
import i18n from '@global/i18n';
import GoogleAnalytics from '@global/lptGoogleAnalytics/GoogleAnalytics';


Vue.config.devtools = true;
Vue.config.productionTip = false;

window.GoogleAnalyticsEventBus = new Vue();

let component = document.getElementById('js-google-analytics-vue-entry');


new Vue({
  el: component,
  i18n,
  ...component.dataset,
  urlEn: component.getAttribute('url-english'),
  categoryPath: component.getAttribute('category-resolve-path'),
  initialState: {
  },
  render: h => h(GoogleAnalytics)
});



// WEBPACK FOOTER //
// ./src/global/lptGoogleAnalytics/entry.js